import { createApi } from '@/lib/api'
import { env } from '@/config/env'
import { clientHeaders } from '@/lib/client-info'
import { queryClient } from '@/lib/query-client'
import { sessionTokenSource, useSessionStore } from '@/stores/session.store'

/** The one HTTP client feature code uses: never import axios directly, its interceptors keep requests authenticated and 401s recoverable. */
export const http = createApi({
  baseUrl: env.apiBaseUrl,
  tokens: sessionTokenSource,
  clientHeaders,
  onSessionExpired: () => {
    // Nothing cached belongs to the next person who signs in on this browser.
    queryClient.clear()
    useSessionStore.getState().markSessionExpired()
  },
})
